/* eslint-disable consistent-return */
import { useEffect } from "react";

import { useSearchParams, useRouter, usePathname } from "next/navigation";

import { AuthStore } from "@packages/store/models/AuthStore";

import { ROUTES } from "@/routes";

export const useEntranceTestCheck = (auth: AuthStore | undefined) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const { isSingIn = false, setEntranceTestId } = auth ?? {};

    const removeSearchParam = (param: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.delete(param);
      router.replace(`${pathname}?${params.toString()}`);
    };

    const testId = searchParams.get("knowledge_test");

    if (testId && setEntranceTestId) {
      setEntranceTestId(testId);

      removeSearchParam("knowledge_test");

      if (!isSingIn) {
        router.replace(ROUTES.REGISTER);
      }
    }
  }, [auth, pathname, router, searchParams]);
};
